var _path, _path2, _g, _g2, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 78,
    viewBox: "0 0 82 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7875 63.3057L31.7205 68.1051C31.7205 68.1051 24.2718 76.5033 10.1443 76.9217C10.1443 76.9217 19.5945 71.9329 20.7875 63.3057Z",
    fill: "url(#paint0_linear_2055_4680)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97827 46.2679C6.97827 63.3318 22.0288 77.1653 40.5942 77.1653C59.1596 77.1653 74.2098 63.3318 74.2098 46.2679C74.2098 29.204 59.1592 15.3682 40.5942 15.3682C22.0291 15.3682 6.97827 29.2027 6.97827 46.2679Z",
    fill: "url(#paint1_linear_2055_4680)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2055_4680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.0141 34.1328H12.2368C8.2314 34.1328 4.98438 37.3798 4.98438 41.3853V52.0944C4.98438 56.0999 8.2314 59.3469 12.2368 59.3469H69.0141C73.0195 59.3469 76.2665 56.0999 76.2665 52.0944V41.3853C76.2665 37.3798 73.0195 34.1328 69.0141 34.1328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0141 60.3319H12.2365C10.0364 60.3319 7.96796 59.4752 6.41234 57.9195C4.85672 56.3639 4 54.2955 4 52.0954V41.3859C4 39.1858 4.85672 37.1174 6.41234 35.5618C7.96796 34.0061 10.0364 33.1494 12.2365 33.1494H69.0141C71.2141 33.1494 73.2826 34.0061 74.8382 35.5618C76.3938 37.1174 77.2505 39.1858 77.2505 41.3859V52.0954C77.2505 54.2955 76.3938 56.3639 74.8382 57.9195C73.2826 59.4752 71.2141 60.3319 69.0141 60.3319ZM12.2365 35.1178C8.78038 35.1178 5.96839 37.9295 5.96839 41.3859V52.0954C5.96839 55.5515 8.78006 58.3635 12.2365 58.3635H69.0141C72.4701 58.3635 75.2821 55.5515 75.2821 52.0954V41.3859C75.2821 37.9298 72.4705 35.1178 69.0141 35.1178H12.2365Z",
    fill: "url(#paint2_linear_2055_4680)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2055_4680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3 46.9352C31.2961 49.2878 29.3926 51.1922 27.0489 51.1883C24.7048 51.1843 22.8076 49.274 22.8115 46.9214C22.8155 44.5684 24.7186 42.664 27.0627 42.668C29.4064 42.6716 31.3039 44.5822 31.3 46.9352Z",
    fill: "url(#paint3_linear_2055_4680)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2055_4680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5541 46.983C58.5501 49.3356 56.647 51.2401 54.3033 51.2361C51.9592 51.2325 50.062 49.3219 50.0659 46.9692C50.0699 44.6163 51.973 42.7119 54.317 42.7158C56.6608 42.7198 58.558 44.6301 58.5544 46.983H58.5541Z",
    fill: "url(#paint4_linear_2055_4680)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1649 5.16071L29.3056 21.1412C29.4031 21.3949 29.6879 21.5215 29.9416 21.424L31.5955 20.7885C31.8493 20.691 31.9759 20.4063 31.8784 20.1525L25.7377 4.17208C25.6402 3.91834 25.3555 3.79169 25.1017 3.88919L23.4478 4.52474C23.1941 4.62224 23.0674 4.90698 23.1649 5.16071Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7616 22.1121C29.6028 22.1121 29.4446 22.0787 29.2953 22.0124C29.0151 21.8877 28.8002 21.6613 28.69 21.3752L22.5479 5.39506C22.3208 4.80411 22.6168 4.13836 23.2077 3.91097L24.8618 3.2754C25.1482 3.16515 25.4603 3.17336 25.7405 3.29804C26.0207 3.42273 26.2356 3.64913 26.3459 3.93525L32.488 19.9154C32.5979 20.2018 32.59 20.5139 32.4653 20.7941C32.3406 21.0743 32.1142 21.2892 31.8281 21.3994L30.174 22.035C30.0402 22.0865 29.9007 22.1121 29.7616 22.1121ZM23.8321 5.07744L29.8564 20.7511L31.204 20.233L25.1797 4.55934L23.8321 5.07744Z",
    fill: "url(#paint5_linear_2055_4680)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2886 7.01521C25.8628 7.01521 27.139 5.73906 27.139 4.16483C27.139 2.59061 25.8628 1.31445 24.2886 1.31445C22.7144 1.31445 21.4382 2.59061 21.4382 4.16483C21.4382 5.73906 22.7144 7.01521 24.2886 7.01521Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.287 8.33016C23.7118 8.33016 23.1382 8.20941 22.5968 7.9689C21.581 7.51708 20.8017 6.69678 20.4027 5.65861C20.0037 4.62076 20.0329 3.48973 20.4847 2.47354C20.9365 1.45768 21.7568 0.678398 22.795 0.279404C23.8329 -0.11959 24.9639 -0.0903875 25.9801 0.361434C26.9959 0.813256 27.7752 1.63356 28.1742 2.67173C28.5732 3.70957 28.544 4.8406 28.0922 5.85679C27.6404 6.87265 26.8201 7.65194 25.7819 8.05093C25.2969 8.2373 24.7913 8.33016 24.287 8.33016ZM24.2889 2.62645C24.1026 2.62645 23.9159 2.6609 23.7367 2.72981C22.9453 3.03397 22.5489 3.92548 22.8531 4.7169C23.0004 5.10047 23.2882 5.40333 23.6636 5.57034C24.0389 5.73735 24.4566 5.74786 24.8402 5.60053C25.2238 5.4532 25.5266 5.16544 25.6936 4.79007C25.8606 4.4147 25.8711 3.99701 25.7238 3.61343C25.5765 3.22986 25.2887 2.92701 24.9134 2.75999C24.7135 2.67107 24.5016 2.62645 24.2889 2.62645Z",
    fill: "url(#paint6_linear_2055_4680)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4523 4.17117L49.3102 20.1513C49.2128 20.4049 49.3394 20.6897 49.593 20.7872L51.2471 21.4227C51.5007 21.5202 51.7855 21.3935 51.883 21.1399L58.0251 5.15979C58.1225 4.90616 57.9959 4.62135 57.7422 4.5239L56.0882 3.88833C55.8345 3.79088 55.5497 3.91753 55.4523 4.17117Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4223 22.1113C51.2855 22.1113 51.1467 22.0867 51.0115 22.0349L49.3575 21.3993C49.071 21.2894 48.845 21.0741 48.7203 20.7939C48.5956 20.5137 48.5877 20.2017 48.6976 19.9152L54.8394 3.93512C54.9493 3.64867 55.1646 3.4226 55.4448 3.29791C55.725 3.17322 56.037 3.16535 56.3235 3.27527L57.9775 3.91117C58.264 4.02109 58.4901 4.23633 58.6147 4.51655C58.7394 4.79676 58.7473 5.10881 58.6374 5.39526L52.4956 21.3754C52.3204 21.8315 51.884 22.1117 51.4223 22.1117V22.1113ZM49.9816 20.2328L51.3292 20.751L57.3534 5.07731L56.0059 4.5592L49.9816 20.2328Z",
    fill: "url(#paint7_linear_2055_4680)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9128 6.18056C60.0259 5.06742 60.0259 3.26266 58.9128 2.14952C57.7996 1.03637 55.9949 1.03637 54.8817 2.14951C53.7686 3.26266 53.7686 5.06742 54.8817 6.18056C55.9949 7.29371 57.7996 7.2937 58.9128 6.18056Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8923 8.32819C56.3965 8.32819 55.8932 8.23894 55.4036 8.05093C53.261 7.22735 52.1881 4.81435 53.0113 2.67173C53.4103 1.63388 54.1896 0.813256 55.2055 0.361434C56.2216 -0.0903875 57.3527 -0.11959 58.3905 0.279404C59.4284 0.678398 60.249 1.45768 60.7008 2.47354C61.1526 3.4894 61.1818 4.62076 60.7828 5.65861C60.1476 7.31167 58.5657 8.32786 56.8927 8.32819H56.8923ZM56.8966 2.62645C56.6843 2.62645 56.4723 2.67107 56.2722 2.75999C55.8968 2.92701 55.609 3.22986 55.4617 3.61343C55.1576 4.40486 55.5539 5.29636 56.3453 5.60053C57.1368 5.9047 58.0283 5.50833 58.3324 4.7169C58.4798 4.33333 58.4689 3.91563 58.3023 3.54026C58.1352 3.16489 57.8324 2.87713 57.4488 2.7298C57.2697 2.6609 57.083 2.62645 56.8966 2.62645Z",
    fill: "url(#paint8_linear_2055_4680)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2055_4680",
    x: 0,
    y: 33.1494,
    width: 81.2505,
    height: 35.1826,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2055_4680"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2055_4680",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2055_4680",
    x: 18.8115,
    y: 42.668,
    width: 16.4885,
    height: 16.5205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2055_4680"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2055_4680",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2055_4680",
    x: 46.0659,
    y: 42.7158,
    width: 16.4885,
    height: 16.5205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2055_4680"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2055_4680",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2055_4680",
    x1: 10.1443,
    y1: 70.1137,
    x2: 31.7205,
    y2: 70.1137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE346E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2055_4680",
    x1: 6.97827,
    y1: 46.2668,
    x2: 74.2098,
    y2: 46.2667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE346E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2055_4680",
    x1: 4,
    y1: 46.7406,
    x2: 77.2505,
    y2: 46.7406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE346E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2055_4680",
    x1: 22.8115,
    y1: 46.9281,
    x2: 31.3,
    y2: 46.9281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE346E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2055_4680",
    x1: 50.0659,
    y1: 46.976,
    x2: 58.5544,
    y2: 46.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE346E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2055_4680",
    x1: 22.4714,
    y1: 12.6552,
    x2: 32.565,
    y2: 12.6552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE346E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2055_4680",
    x1: 20.1233,
    y1: 4.16508,
    x2: 28.4536,
    y2: 4.16508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE346E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2055_4680",
    x1: 48.6206,
    y1: 12.655,
    x2: 58.7144,
    y2: 12.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE346E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2055_4680",
    x1: 52.7341,
    y1: 4.1641,
    x2: 61.0623,
    y2: 4.1641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9BC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE346E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIa);
export default __webpack_public_path__ + "static/media/IA.75397c7a4c8031cf307c9b6eec9546c4.svg";
export { ForwardRef as ReactComponent };